import React, { useState, useEffect } from "react";
import { getaxiosadminRequestWithToken, getaxiosRequestWithToken, postaxiosadminRequestWithToken, postaxiosRequestWithToken } from "../../api/api";
import { showToast } from "../../services/toastifyservices";
import { handleSession } from "../../api/apiSessionHandle";
import { useNavigate } from "react-router-dom";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer, BarChart, XAxis, YAxis, Bar } from "recharts";
import { useSelector } from "react-redux";
import endpoints from "../../api/EndPoints";
import "./dashboard.css";

const Dashboard = () => {
  const navigate = useNavigate();
  const [callList, setCallList] = useState(null);
  const [loading, setLoading] = useState(true);
  const [date, setdate] = useState(null);
  const [StartDate, setStartDate] = useState(new Date().toISOString().split("T")[0]);
  const [endDate, setEndDate] = useState(new Date().toISOString().split("T")[0]);
  const [ClaimStatusLoader, setClaimStatusLoader] = useState(false);

  const [selectedOperator, setselectedOperator] = useState('');
  const [providers, setProviders] = useState([]);
  const [provider_id, setProviderId] = useState("");
  const [AppoinementClaimStatusList, setAppoinementClaimStatusList] = useState("");
  const [DictationCountList, setDictationCountList] = useState("");
  const [dictationLoader, setdictationLoader] = useState("");
  const [status, setStatus] = useState("");
  const [dicationStartDate, setdicationStartDate] = useState('');
  const [dicationendDate, setdicationEndDate] = useState('');

  const COLORS = ['#FF6B6B', '#FFD93D', '#6BCB77', '#4D96FF', '#845EC2', '#00C9A7', '#C34A36', '#FFC75F', '#F9F871', '#9B89B3'];

  const role = useSelector((state) => state.auth?.role);

  useEffect(() => {
    if (role === "Admin") {
      FetchCallList();
    }
  }, [role]); // Runs once when the component mounts and when `role` changes.
  useEffect(() => {
    if (role === "Admin") {
      fetchProviders();
    }
  }, []);

  const FetchDictationCount = async () => {
    setdictationLoader(true);
    try {
      let param = {
        status: status,
        start_date: dicationStartDate,
        end_date: dicationendDate
      }
      const response = await postaxiosRequestWithToken(endpoints.GetDictationCount, param);
      if (response.success) {
        setDictationCountList(response.data);
      }
    } catch (error) {
      showToast("error", error.response?.data?.message);
      handleSession(error.response?.data, navigate);
    } finally {
      setdictationLoader(false);
      setClaimStatusLoader(false)
    }
  };

  const FetchCallList = async () => {
    setLoading(true);
    try {
      const response = await getaxiosadminRequestWithToken(endpoints.calllistanalytics);
      if (response.success) {
        setCallList(response.data);
      }
    } catch (error) {
      showToast("error", error.response?.data?.message);
      handleSession(error.response?.data, navigate);
    } finally {
      setLoading(false);
      setClaimStatusLoader(false)
    }
  };
  const fetchProviders = async () => {
    try {
      const response = await getaxiosadminRequestWithToken(endpoints.FetchProvider);
      if (response.success) {
        //
        setProviders(response.data.data || []);
      }
    } catch (error) {
      showToast('error', error.response?.data.message);
      handleSession(error.response?.data, navigate);
    } finally {
    }
  };

  const SearchFetchList = async () => {
    setLoading(true);
    try {
      let queryParams = new URLSearchParams();
      if (selectedOperator) {
        if (!date) {
          showToast('error', "please select date");
          return
        }
      }
      if (date && selectedOperator) {
        queryParams.append(selectedOperator, date);
      } else if (date) {
        // Case 2: Only date is selected (Default to `createdAtGt`)
        //queryParams.append("createdAtGt", selectedDate);
      }

      // Construct the final URL
      let url = endpoints.calllistanalytics;
      if (queryParams.toString()) {
        url += `?${queryParams.toString()}`;
      }
      const response = await getaxiosadminRequestWithToken(url);
      if (response.success) {
        setCallList(response.data);
      }
    } catch (error) {
      showToast("error", error.response?.data?.message);
      handleSession(error.response?.data, navigate);
    } finally {
      setLoading(false);
    }
  };


  const SearchAppoinementClaimStatus = async () => {
    if (!provider_id) {
      showToast('error', 'Please select provider');
      return;

    }
    setClaimStatusLoader(true);
    const Payload = {
      provider_id: provider_id,
      start_date: StartDate,
      end_date: endDate,
    };
    try {
      const response = await postaxiosadminRequestWithToken(endpoints.SearchClaimStatusAnalytics, Payload);

      if (response.success) {
        setAppoinementClaimStatusList(response.data || {});

      }
    } catch (error) {
      showToast('error', error.response?.data.message);
      setClaimStatusLoader(false);
      handleSession(error.response?.data, navigate);
    } finally {
      setClaimStatusLoader(false);
    }
  };

  if (role !== "Admin") {
    return (
      <div className="dashboard-container">
        <p>Welcome to Assistant Panel Dashboard</p>
      </div>
    );
  } else {
    <div class="dashboard-container">
      <p>Welcome to Assistant Panel Dashboard</p>
    </div>
  }

  // if (loading) {
  //   return <CommonSpinner />; // Show spinner while loading
  // }

  return (
    <div className="mt-3 p-2 md:p-10 bg-gray-200">
      <div className="card">
        <span className="text-start font-bold ml-4 p-2 headingtext">Dashboard</span>
      </div>
      <div className="card p-3 mt-3">

        <div className="row">
          <span className="text-start font-semibold  headingtext mb-3" style={{ fontSize: "27px" }}>Calls Forwarding</span>
        </div>

        <div className="row">
          <div className="col-md-3">
            <label className="form-label font-bold">Date</label>
            <input
              type="date"
              className="form-control"
              value={date}
              onChange={(e) => setdate(e.target.value)}
            />
          </div>
          <div className="col-md-3 mb-1">
            <label className="form-label font-bold">Operator Name</label>
            <select
              className="form-select"
              value={selectedOperator}
              onChange={(e) => setselectedOperator(e.target.value)}
            >
              <option value="">Select Operator</option>
              <option value="createdAtGt">&gt;</option>
              <option value="createdAtLt">&lt;</option>
              <option value="createdAtGe">&ge;</option>
              <option value="createdAtLe">&le;</option>
            </select>

          </div>
          <div className="col-md-3 mt-2">
            <button
              className="btn btn-primary fw-bold btncolor mt-4"
              onClick={SearchFetchList}
            >
              SEARCH
            </button>
          </div>


        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-6 mt-3">
          <div className="p-6 bg-gradient-to-r from-blue-600 to-indigo-700 text-white rounded-2xl shadow-lg hover:shadow-xl transition duration-300">
            <h3 className="text-lg font-semibold opacity-80">Total Calls</h3>
            <p className="text-4xl font-bold mt-2">{callList?.totalCalls}</p>
          </div>

          <div className="p-6 bg-gradient-to-r from-green-600 to-emerald-700 text-white rounded-2xl shadow-lg hover:shadow-xl transition duration-300">
            <h3 className="text-lg font-semibold opacity-80">Total Cost</h3>
            <p className="text-4xl font-bold mt-2">${callList?.totalCost?.toFixed(2)}</p>
          </div>
        </div>

        {/* Charts Section */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {/* Reason Call Ended Pie Chart */}
          <div className="p-6 bg-white text-black border border-gray-300 rounded-2xl shadow-md hover:shadow-lg transition duration-300">
            <h3 className="text-lg font-semibold mb-4">Reason Call Ended</h3>
            {loading ? (
              <div className="flex justify-center items-center h-[300px]">
                <span className="animate-spin border-4 border-gray-300 border-t-red-500 rounded-full w-10 h-10"></span>
              </div>
            ) : (
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={callList?.endedReasons || []}
                    dataKey="count"
                    nameKey="reason"
                    cx="50%"
                    cy="50%"
                    outerRadius={110}
                    fill="#FF6B6B"
                    label
                  >
                    {callList?.endedReasons?.map((_, index) => (
                      <Cell key={index} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <Tooltip />
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            )}
          </div>

          {/* Forwarded Calls By Team Pie Chart */}
          <div className="p-6 bg-white text-black border border-gray-300 rounded-2xl shadow-md hover:shadow-lg transition duration-300">
            <h3 className="text-lg font-semibold mb-4">Forwarded Calls by Team</h3>
            {loading ? (
              <div className="flex justify-center items-center h-[300px]">
                <span className="animate-spin border-4 border-gray-300 border-t-yellow-500 rounded-full w-10 h-10"></span>
              </div>
            ) : (
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={callList?.forwardedCallsByTeam || []}
                    dataKey="count"
                    nameKey="team"
                    cx="50%"
                    cy="50%"
                    outerRadius={110}
                    fill="#FFD93D"
                    label
                  >
                    {callList?.forwardedCallsByTeam?.map((_, index) => (
                      <Cell key={index} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <Tooltip />
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            )}
          </div>
        </div>
      </div>

      {/* <div className="card p-3 mt-3">

        <div className="row">
          <span className="text-start font-semibold  headingtext mb-3" style={{ fontSize: "27px" }}>Drafting</span>
        </div>

        <div className="row">
          <div className="col-md-3">
            <label
              htmlFor="providerselect"
              className="form-label font-bold"
              style={{ minWidth: "100px" }}
            >
              Provider
            </label>
            <select
              className="form-select "
              aria-label="Default select example"
              id="providerselect"
              value={provider_id}
              onChange={(e) => setProviderId(e.target.value)}
              required
            >
              <option value="">Select Name</option>
              {providers.map((provider) => (
                <option key={provider.azz_id} value={provider.azz_id}>
                  {provider.name}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-3">
            <label className="form-label font-bold">Start Date</label>
            <input
              type="date"
              className="form-control"
              value={StartDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label font-bold">End Date</label>
            <input
              type="date"
              className="form-control"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
          <div className="col-md-3 mt-2">
            <button
              className="btn btn-primary fw-bold btncolor mt-4"
              onClick={SearchAppoinementClaimStatus}
            >
              SEARCH
            </button>
          </div>


        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-3">
          <div className="p-6 bg-white text-black border border-gray-300 rounded-2xl shadow-md hover:shadow-lg transition duration-300">
            <h3 className="text-lg font-semibold mb-4">Claim Status Counts</h3>
            {ClaimStatusLoader ? (
              <div className="flex justify-center items-center h-[300px]">
                <span className="animate-spin border-4 border-gray-300 border-t-green-500 rounded-full w-10 h-10"></span>
              </div>
            ) : (
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={Object.entries(AppoinementClaimStatusList?.claim_status_counts || []).map(([name, count]) => ({
                      name,
                      count,
                    }))}
                    dataKey="count"
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    outerRadius={110}
                    fill="#4CAF50"
                    label
                  >
                    {Object.keys(AppoinementClaimStatusList?.claim_status_counts || {}).map((_, index) => (
                      <Cell key={index} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <Tooltip />
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            )}
          </div>

          <div className="p-6 bg-white text-black border border-gray-300 rounded-2xl shadow-md hover:shadow-lg transition duration-300 mt-5">
            <h3 className="text-lg font-semibold mb-4">Appointment Status Counts</h3>
            {ClaimStatusLoader ? (
              <div className="flex justify-center items-center h-[300px]">
                <span className="animate-spin border-4 border-gray-300 border-t-green-500 rounded-full w-10 h-10"></span>
              </div>
            ) : (
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={Object.entries(AppoinementClaimStatusList?.appointment_status_counts || []).map(([name, count]) => ({
                      name,
                      count,
                    }))}
                    dataKey="count"
                    nameKey="name"
                    cx="50%"
                    cy="50%"
                    outerRadius={110}
                    fill="#4CAF50"
                    label
                  >
                    {Object.keys(AppoinementClaimStatusList?.appointment_status_counts || {}).map((_, index) => (
                      <Cell key={index} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <Tooltip />
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            )}
          </div>
        </div>

      </div> */}

      <div className="card p-3 mt-3">
        <div className="row">
          <span className="text-start font-semibold  headingtext mb-3" style={{ fontSize: "27px" }}>Dictation Counts</span>
        </div>

        <div className="row">
          <div className="col-md-3">
            <label
              htmlFor="providerselect"
              className="form-label font-bold"
              style={{ minWidth: "100px" }}
            >
              Provider
            </label>
            <select
              className="form-select"
              id="statusSelect"
              value={status}
              required
              onChange={(e) => setStatus(e.target.value)}
            >
              <option value="">Select Status</option>
              <option value="completed">Completed</option>
              <option value="pending">Pending</option>
            </select>

          </div>
          <div className="col-md-3">
            <label className="form-label font-bold">Start Date</label>
            <input
              type="date"
              className="form-control"
              value={date}
              onChange={(e) => setdicationStartDate(e.target.value)}
            />
          </div>
          <div className="col-md-3">
            <label className="form-label font-bold">End Date</label>
            <input
              type="date"
              className="form-control"
              value={date}
              onChange={(e) => setdicationEndDate(e.target.value)}
            />
          </div>
          <div className="col-md-3 mt-2">
            <button
              className="btn btn-primary fw-bold btncolor mt-4"
              onClick={FetchDictationCount}
            >
              SEARCH
            </button>
          </div>


        </div>
        <div className="grid grid-cols-1 md:grid-cols gap-6 mt-3">
          {/* Reason Call Ended Pie Chart */}
          <div className="p-6 bg-white text-black border border-gray-300 rounded-2xl shadow-md hover:shadow-lg transition duration-300">

            {dictationLoader ? (
              <div className="flex justify-center items-center h-[300px]">
                <span className="animate-spin border-4 border-gray-300 border-t-red-500 rounded-full w-10 h-10"></span>
              </div>
            ) : (
              <>
                <div className="overflow-y-auto max-h-[600px]"
                >
                  <ResponsiveContainer
                    width="100%"
                    height={Math.max(300, (DictationCountList?.providers?.length || 0) * 30)}
                  >
                    <BarChart
                      data={DictationCountList?.providers || []}
                      layout="vertical"
                      margin={{ top: 5, right: 30, left: 150, bottom: 5 }}
                    >
                      <XAxis type="number" />
                      <YAxis
                        dataKey="provider_name"
                        type="category"
                        width={200}
                        tick={{ fontSize: 12 }}
                      />
                      <Tooltip />
                      <Bar dataKey="dictation_count">
                        {(DictationCountList?.providers || []).map((_, index) => (
                          <Cell key={index} fill={COLORS[index % COLORS.length]} />
                        ))}
                      </Bar>
                    </BarChart>
                  </ResponsiveContainer>
                </div>
              </>

            )}
          </div>


        </div>
      </div>

    </div>
  );
};

export default Dashboard;
